/* @flow */

import { type State } from '../../preact-app/types';
import relatorios, { type CadastroUsuariosPorMes } from '../../relatorios/relatorios';
import { type CadastrosClientesState } from './cadastros-clientes-types';

type SetBalcaoAction = {
    type: 'relatorios/cadastros-clientes/SET_BALCAO',
    balcao: CadastroUsuariosPorMes[],
};

type SetAppAction = {
    type: 'relatorios/cadastros-clientes/SET_APP',
    app: CadastroUsuariosPorMes[],
};

type SetTotalAction = {
    type: 'relatorios/cadastros-clientes/SET_TOTAL',
    total: CadastroUsuariosPorMes[],
};

type LoadingAction = {
    type: 'relatorios/cadastros-clientes/LOADING',
    isLoading: boolean,
};

type Actions = SetBalcaoAction | SetAppAction | SetTotalAction | LoadingAction;

// Action Types

const SET_BALCAO = 'relatorios/cadastros-clientes/SET_BALCAO';
const SET_APP = 'relatorios/cadastros-clientes/SET_APP';
const SET_TOTAL = 'relatorios/cadastros-clientes/SET_TOTAL';
const LOADING = 'relatorios/cadastros-clientes/LOADING';

// Action creators

const setBalcao = (balcao: CadastroUsuariosPorMes[]): SetBalcaoAction => ({
    type: SET_BALCAO,
    balcao,
});

const setApp = (app: CadastroUsuariosPorMes[]): SetAppAction => ({
    type: SET_APP,
    app,
});

const setTotal = (total: CadastroUsuariosPorMes[]): SetTotalAction => ({
    type: SET_TOTAL,
    total,
});

const loading = (isLoading: boolean): LoadingAction => ({
    type: LOADING,
    isLoading,
});

// Selectors

const getCadastrosClientes = (state: State) => state.relatorios.cadastrosClientes;
export const getApp = (state: State) => getCadastrosClientes(state).app;
export const getTotal = (state: State) => getCadastrosClientes(state).total;
export const getBalcao = (state: State) => getCadastrosClientes(state).balcao;
export const isLoading = (state: State) => getCadastrosClientes(state).isLoading;

// Thunks

export const buscar = () => (dispatch: Function) => Promise.resolve()
    .then(dispatch(loading(true)))
    .then(() => (
        Promise.all([
            relatorios.cadastrosUsuariosPorMes({ nivel: 'C', origem: 'app' })
                .then(response => dispatch(setApp(response.data))),
            relatorios.cadastrosUsuariosPorMes({ nivel: 'C', origem: 'balcao' })
                .then(response => dispatch(setBalcao(response.data))),
            relatorios.cadastrosUsuariosPorMes({ nivel: 'C' })
                .then(response => dispatch(setTotal(response.data))),
        ])
    ))
    .then(dispatch(loading(false)));

// Reducer

const initialState = {
    app: [],
    balcao: [],
    total: [],
    isLoading: false,
};

const cadastrosClientesReducer = (
    state: CadastrosClientesState = initialState,
    action: Actions,
): CadastrosClientesState => {
    switch (action.type) {
    case SET_APP: {
        const { app } = action;
        return { ...state, app };
    }
    case SET_BALCAO: {
        const { balcao } = action;
        return { ...state, balcao };
    }
    case SET_TOTAL: {
        const { total } = action;
        return { ...state, total };
    }
    case LOADING: {
        return { ...state, isLoading: action.isLoading };
    }
    default:
        return state;
    }
};

export default cadastrosClientesReducer;
